import React from "react";
import "./refundpolicy.css";
const RefundPolicy = () => {
  return (
    <>
      <section class="OP_BannerPRIVACY clearfix">
        <div class="container-fluid">
          <h2>Refund and Cancellation Policy</h2>
        </div>
      </section>

      <section class="space contact_us_bgcol pb-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <p class="service-content">
                <b>Booking Policy: - </b>
                The total price displayed on the site includes all applicable
                government taxes. You are required to pay the entire amount
                before the confirmation of your booking. In case of an increase
                in the fare in the issuance of the Air ticket, due to airlines,
                a miscalculation in the amount due to server error and from the
                bank's payment gateway issue then reserves the right to cancel
                the ticket and forfeit the amount received as Cancellation
                Charges. The difference of amount should be paid to DMT EMPIRE INDIA PRIVATE LIMITED after the communication from{" "}
                <b class="dmt-D">D</b>
                <b class="dmt-M">M</b>
                <b class="dmt-T">T</b> to avoid any discomfort.
                <br />
                <br />
                To get an infant’s ticket issued, the age of the infant must be
                below 24 months and have valid proof-of-age documents when they
                are checking in, and the infant must always be accompanied by an
                adult at least 18 years old. You can book no more than one
                infant per adult. To avail infant fares; the infant must be
                under 24 months of age throughout the entire itinerary that
                you’re booking. If the age of the infant is 24 months or above,
                then you need to book a separate booking as a child.
                <br />
                <br />
                To get any child ticket issued, the age of the child must in
                between 2-12 years and make sure that they have valid
                proof-of-age documents when they’re checking in, and the child
                must always be accompanied by an adult at least 18 years old.
                All the tickets/bookings issued to the customer shall
                additionally be governed under the terms and conditions as laid
                out by the respective Airlines/Supplier. The company is not
                responsible for any delay or cancellation of flights from the
                airline's end. If a ticket is cancelled directly from the
                airline's website, office, or call center, the customer needs to
                inform dmtkendra.com for the refund to be processed. Please
                note that dmtkendra.com do not get any alert from
                Airlines/Hotel/Transporter and any Other Suppliers directly.
              </p>

              <p class="service-content margin-top">
                <b>Flight Amendment & Cancellation Policy</b>
                <br />
                Every booking made on dmtkendra.com is subject to cancellation
                charges levied by the airline, which may vary with respect to
                flight and booking class.
                <br />
                <br />
                dmtkendra.com levies a negligible amount of 250 Rs. per
                passenger/per sector for domestic and 350 Rs. per passenger/per
                sector for international air tickets as cancellation service
                charges. Some bookings may be non-refundable as per the specific
                airline’s policy. Some bookings cannot be cancelled partially as
                per the specific airline’s policy.
                <br />
                <br />
                Cancellations can be made online or offline through the My
                Account section or by sending an email to info@dmtgroup.in We
                assist you in making various amendments for bookings. In few
                cases, you need to contact the airline directly. Amendment
                charges on dmtkendra.com are subject to change as per the
                policy of the airline, which varies due to flight timings and
                booking classes.
                <br />
                <br />
                To cancel the tickets within 24 Hrs of the journey, DMT
                recommends the customer contact directly to the airline and
                after that, send the cancellation request on our website for
                refunds.
                <br />
                <br />
                In case of direct cancellation through airlines, refunds will be
                given according to airlines charges along with our service
                charge as above mentioned. After flight departure & in case of
                No Show, we don't entertain any cancelation request. In case of
                a No-show, the refund amount entirely depends upon the airlines.
                DMT has nothing to do with the refund amount. DMT
                will refund the same amount to the customer, which we receive
                from airlines in case of No-Show.
                <br />
              </p>
              <p class="service-content margin-top">
                <b>Holidays Amendment & Cancellation Policy</b>
                <br />
                For cancellations done before the 30 days or more of the date of
                departure, the initial deposit amount or 25% of the tour cost
                (if fully paid) will be charged as cancellation charges.
                <br />
                For cancellations done between 29 days to 15 days before the
                date of departure, 50% of the tour cost will be charged as
                cancellation charges.
                <br />
                <br />
                For cancellations done between 14 days to 8 days of the tour,
                75% of the tour cost will be charged as cancellation charges
                <br />
                For cancellations done within 8 days of the tour, 100%
                cancellation charges will apply and you will receive no refunds.
                <br />
              </p>

              <p class="service-content margin-top">
                <b>General Cancellation Policy</b>
                <br />
                The user agrees that there can be exceptional circumstances
                where the service operators like the airlines, hotels, the
                respective transportation providers or concerns may be unable to
                honour the confirmed bookings due to various reasons like
                climatic conditions, labour unrest, insolvency, business
                exigencies, government decisions, operational and technical
                issues, route and flight cancellations, etc. If the company is
                informed in advance of such situations where dishonour of
                bookings may happen, it will make its best efforts to provide a
                similar alternative to its customers or refund the booking
                amount after reasonable service charges, if supported and
                refunded by that respective service operators. The user agrees
                that the company being an agent for facilitating the booking
                services shall not be responsible for any such circumstances and
                the customers have to contact that service provider directly for
                any further resolutions and refunds.
                <br />
                <br />
                The user agrees that in situations due to any technical or other
                failures in the company, services committed earlier may not be
                provided or may involve substantial modification. In such cases,
                the company shall refund the entire amount received from the
                customer for availing of such services minus the applicable
                cancellation, refund, or other charges, which shall completely
                discharge any or all liabilities of the company against such
                non-provision of services or deficiencies. Additional
                liabilities, if any, shall be borne by the user.
                <br />
                <br />
                The company shall not be liable for delays or inabilities in
                performance or non-performance in whole or in part of its
                obligations due to any causes that are not due to its acts or
                omissions and are beyond its reasonable control, such as acts of
                God, fire, strikes, embargo, acts of government, acts of
                terrorism or other similar causes, problems at airlines, rails,
                buses, hotels or transporters end. In such an event, the user
                affected will be promptly given notice as the situation permits.
                <br />
                <br />
                Without prejudice to whatever is stated above, the maximum
                liability on part of the company arising under any
                circumstances, in respect of any services offered on the site,
                shall be limited to the refund of the total amount received from
                the customer for availing the services less any cancellation,
                refund or others charges, as may be applicable. In no case, the
                liability shall include any loss, damage, or additional expense
                whatsoever beyond the amount charged by the company for its
                services.
                <br />
                In no event shall the company and/or its suppliers be liable for
                any direct, indirect, punitive, incidental, special,
                consequential damages or any damages whatsoever including,
                without limitation, damages for loss of use, data or profits,
                arising out of or in any way connected with the use or
                performance of the company website(s) or any other channel.
                Neither shall the Company be responsible for the delay or
                inability to use the company websites or related services, the
                provision of or failure to provide services, or for any
                information, software, products, services, and related graphics
                obtained through the company website(s), or otherwise arising
                out of the use of the company website(s), whether based on
                contract, tort, negligence, strict liability or otherwise.
                <br />
                The company is not responsible for any errors, omissions, or
                representations on any of its pages or links or any of the
                linked website pages.
                <br />
              </p>

              <p class="service-content margin-top">
                <b>General Refund Policy</b>
                <br />
                DMT will process the refund only after getting a
                cancellation request/claim from the customer/travel
                agent/corporate company through the My Account section or email.
                <br />
                <br />
                Refund against the cancellation of air tickets will be credited
                directly in the customer’s mode of payment after receiving the
                refund amount from Airlines/Hotel/Transporter and any Other
                Suppliers.
                <br />
                <br />
                DMT will process a refund within 72 only after receiving
                it from the concerned Airlines/hotel/transporter/other
                suppliers. Due to Banking Procedures, Refund on credit cards may
                take 72 hours while it may take 7 days in case of net banking
                transactions Refunds in cases where Airlines/Hotel is declared
                as In-solvent or Bankrupt
                <br />
                <br />
                DMT shall not be liable to pay any refunds whatsoever in
                cases where the Airlines/Hotel closes its operations or declares
                itself as insolvent. The customers or clients or agents shall
                not hold the DMT liable to pay the refunds as assured at
                the time of booking of a ticket in cases where the
                Airlines/Hotel closes its operation or declares itself as
                insolvent.
                <br />
                <br />
                Based on surety given by airlines/hotels/suppliers, DMT
                may sometimes refund the amount to the customer but DMT
                reserves the right to recover the refunded amount in event of
                Airlines/hotels getting shut down/non-operational/bankrupt.
                <br />
              </p>
              <p class="semi-bold-txt margin-top-x2 pb-sm-5">
                <b>
                  Thanking you for using <span class="dmt-D">D</span>
                  <span class="dmt-M">M</span>
                  <span class="dmt-T">T </span>
                     EMPIRE INDIA PRIVATE LIMITED
                </b>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RefundPolicy;
